<script setup lang="ts">
  import { computed } from "vue";
  import { IconMenuStamp, Text } from "@ui-kit";
  import { useDeviceInfo } from "@plugins";
  import { useProfileOptions } from "@src/hooks";
  import { useWidgetsStore } from "@src/store";
  import { default as MainPageAction } from "./MainPageAction.vue";

  const { deviceInfo } = useDeviceInfo();
  const { hasPermission } = useProfileOptions();
  const widgets_store = useWidgetsStore();

  const isAvailableAction = computed(() => {
    return hasPermission("mobile.pair_verify") && deviceInfo?.value.isRfidReader;
  });
</script>

<template>
  <MainPageAction
    v-if="isAvailableAction"
    @click="() => widgets_store.open('check_pairs')"
    data-testid="action-check-pairs"
  >
    <template #icon>
      <IconMenuStamp />
    </template>
    <template #text>
      <Text font="body-regular-18" :wrap="false">{{ $t("Проверка КИЗ+EPC") }}</Text>
    </template>
  </MainPageAction>
</template>
